var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07187 20.2034C3.44221 20.2034 2.90562 19.9816 2.46213 19.5381C2.01863 19.0946 1.79688 18.558 1.79688 17.9284V6.07187C1.79688 5.44221 2.01863 4.90562 2.46213 4.46212C2.90562 4.01862 3.44221 3.79688 4.07187 3.79688H14.9284C15.29 3.79688 15.6326 3.87779 15.9561 4.03963C16.2798 4.20129 16.5463 4.42487 16.7556 4.71037L22.2034 12.0001L16.7556 19.2899C16.5463 19.5754 16.2798 19.799 15.9561 19.9606C15.6326 20.1225 15.29 20.2034 14.9284 20.2034H4.07187ZM4.06588 17.9344H14.9404L19.3686 12.0001L14.9404 6.06588H4.06588V17.9344Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLabel);
export default __webpack_public_path__ + "static/media/icon-label.2f6b58ad8d33c0a9c2727306022434e8.svg";
export { ForwardRef as ReactComponent };